// extracted by mini-css-extract-plugin
export default {"content":"checkbox_content__U2xvc","selectBtn":"checkbox_selectBtn__j0gNY","unSelectBtn":"checkbox_unSelectBtn__42-Iz"};